<ion-content>
  <ion-grid style="margin: 3px">
    <ion-row class="ion-justify-content-end">
      <ion-col size="auto" class="no-padding">
        <div class="flexed">
          <ion-searchbar
            mode="ios"
            class="rounded-search-bar"
            placeholder="Search people..."
            showCancelButton="never"
            [(ngModel)]="searchText"
          ></ion-searchbar>
          <ion-select
            *ngIf="connectedTeams?.length > 1"
            [(ngModel)]="selectedTeamId"
            (ionChange)="selectedUserGroup = undefined; updateFilteredUsers(); fetchUserGroups()"
            interface="popover"
            placeholder="Select workspace"
            aria-label="Select workspace"
            class="select-outline input-field"
            style="font-size: 0.8rem; width: 210px; margin: 4px"
          >
            <ion-select-option [value]="null"> All workspaces </ion-select-option>
            <ion-select-option *ngFor="let connectedTeam of connectedTeams" [value]="connectedTeam.id">
              {{ connectedTeam.name }} workspace
            </ion-select-option>
          </ion-select>
          <ion-select
            *ngIf="userGroups?.length > 1"
            [(ngModel)]="selectedUserGroup"
            (ionChange)="updateFilteredUsers()"
            interface="popover"
            placeholder="Select user group"
            aria-label="Select user group"
            class="select-outline input-field"
            style="font-size: 0.8rem; width: 180px; margin: 4px"
          >
            <ion-select-option [value]="null"> All internal users </ion-select-option>
            <ion-select-option *ngFor="let group of userGroups" [value]="group">
              {{ group.name }}
            </ion-select-option>
          </ion-select>
          <ion-select
            [(ngModel)]="selectedRole"
            (ionChange)="updateFilteredUsers()"
            interface="popover"
            placeholder="Select role"
            aria-label="Select role"
            class="select-outline input-field"
            style="font-size: 0.8rem; width: 180px; margin: 4px"
            [hidden]="selectedUserGroup?.isExternal"
          >
            <ion-select-option [value]="null"> All roles </ion-select-option>
            <ion-select-option value="owner"> Owners </ion-select-option>
            <ion-select-option value="admin"> Admins </ion-select-option>
          </ion-select>
        </div>
      </ion-col>

      <ion-col size="auto" class="no-padding" [hidden]="selectedUserGroup?.isExternal">
        <ion-button (click)="inviteUser()" routerDirection="root" [disabled]="isLoading">
          <ion-icon name="send-outline"></ion-icon>
          <span class="text-with-left-icon"> Invite user </span>
        </ion-button>
      </ion-col>

      <ion-col size="auto" class="no-padding" [hidden]="selectedUserGroup?.isExternal || accountsModeEnabled">
        <ion-button fill="clear" color="dark" [disabled]="isLoading" (click)="showTeamOptionsModal = true">
          <ion-icon name="cog-outline"></ion-icon>
          <span class="text-with-left-icon"> Options </span>
        </ion-button>
      </ion-col>

      <ion-col size="auto" class="no-padding" [hidden]="selectedUserGroup?.isExternal">
        <ion-button
          fill="clear"
          color="dark"
          (click)="showInactiveUsers = !showInactiveUsers; updateFilteredUsers()"
          [disabled]="isLoading"
        >
          <ion-icon [name]="showInactiveUsers ? 'eye-off-outline' : 'eye-outline'" class="padded-icon checkbox-icon">
          </ion-icon>
          {{ showInactiveUsers ? 'Hide deactivated' : 'Show deactivated' }}
        </ion-button>
      </ion-col>

      <ion-col size="auto" class="no-padding">
        <ion-button fill="clear" color="dark" (click)="downloadUsers()" [disabled]="isLoading">
          <ion-icon name="cloud-download-outline"></ion-icon>
        </ion-button>
      </ion-col>

      <ion-col size="auto" class="no-padding">
        <ion-button (click)="changeColumns()" [disabled]="isLoading" fill="clear" color="dark">
          <ion-icon name="reorder-four"></ion-icon>
          <ion-icon name="chevron-down-outline" class="button-icon"></ion-icon>
        </ion-button>
        <ion-chip [outline]="true" color="dark" *ngFor="let filter of filters; let i = index" (click)="removeFilter(i)">
          <span style="font-weight: 600">{{ filter.label }}:</span>&nbsp;<span>{{ filter.value }}</span>
          <ion-icon name="close-circle"></ion-icon>
        </ion-chip>
      </ion-col>
    </ion-row>
  </ion-grid>

  <ion-card class="outline-card" style="margin: 0 12px 12px">
    <ngx-datatable
      [limit]="100"
      [loadingIndicator]="isLoading"
      class="material datatable-row-borders"
      [columnMode]="ColumnMode.force"
      [headerHeight]="44"
      [footerHeight]="50"
      [rowHeight]="56"
      [scrollbarH]="true"
      [rows]="users$ | async | filterCollection: searchText : selectedColumnIds"
      [selectionType]="SelectionType.checkbox"
      [selectAllRowsOnPage]="false"
      [displayCheck]="false"
      trackByProp="id"
      (select)="onSelect($event)"
    >
      <ngx-datatable-column
        *ngFor="let column of columns | filterCollection: 'true' : ['selected']"
        [name]="column.label"
        [prop]="column.id"
        [minWidth]="column.minWidth"
      >
        <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
          <div style="display: flex; align-items: center">
            <ng-container [ngSwitch]="column.id">
              <ng-container *ngSwitchCase="'name'">
                <ion-avatar class="user-photo clickable" [routerLink]="['/dashboard/people', row.id]">
                  <app-avatar size="40" [name]="row.name" [image]="row.photo"></app-avatar>
                </ion-avatar>
                <a [routerLink]="['/dashboard/people', row.id]" class="row-title">
                  {{ row.name }}
                </a>
                <i
                  [routerLink]="['/dashboard/people', row.id]"
                  class="text-link clickable"
                  *ngIf="!row.lastSeenAt && row.invitedAt"
                  >&nbsp;(Invite pending)</i
                >
              </ng-container>

              <ng-container *ngSwitchCase="'lastSeenAt'">
                {{ value | date: 'MMM d yyyy h:mm a' }}
              </ng-container>

              <ng-container *ngSwitchCase="'createdAt'">
                {{ value | date: 'MMM d yyyy h:mm a' }}
              </ng-container>

              <ng-container *ngSwitchCase="'status'">
                <div
                  *ngIf="row.status === 'inactive'"
                  ngxTippy
                  data-tippy-content="User is no longer able to access Unthread."
                  [tippyProps]="{
                    placement: 'bottom'
                  }"
                >
                  <ion-label color="danger">
                    <ion-icon name="warning-outline"></ion-icon>
                    Deactivated
                  </ion-label>
                </div>
                <div *ngIf="row.status !== 'inactive'">
                  {{ getAwayStatus(row) }}
                </div>
                <a (click)="showDeactivateOption(row)">
                  <ion-icon name="chevron-down-outline"></ion-icon>
                </a>
              </ng-container>

              <ng-container *ngSwitchCase="'role'">
                <div
                  *ngIf="row.status === 'inactive'"
                  ngxTippy
                  data-tippy-content="User is no longer able to access Unthread."
                  [tippyProps]="{
                    placement: 'bottom'
                  }"
                >
                  <ion-label color="danger">
                    <ion-icon name="warning-outline"></ion-icon>
                    Deactivated
                  </ion-label>
                </div>

                <ng-container *ngIf="row.status !== 'inactive'">
                  <div
                    *ngIf="row.role === TENANT_USER_ROLES.OWNER"
                    ngxTippy
                    data-tippy-content="Can configure all aspects of the workspace and view all data in the workspace"
                    [tippyProps]="{
                      placement: 'bottom'
                    }"
                  >
                    <ion-icon name="shield-checkmark" color="warning"></ion-icon>
                    Owner
                    <a (click)="changeRole(row.id)" *ngIf="authService.isTenantOwner">
                      <ion-icon name="chevron-down-outline"></ion-icon>
                    </a>
                  </div>

                  <div
                    *ngIf="row.role === TENANT_USER_ROLES.ADMIN"
                    ngxTippy
                    data-tippy-content="Can configure all aspects of the workspace"
                    [tippyProps]="{
                      placement: 'bottom'
                    }"
                  >
                    <ion-icon name="shield" color="success"></ion-icon>
                    Admin
                    <a (click)="changeRole(row.id)" *ngIf="authService.isTenantAdmin">
                      <ion-icon name="chevron-down-outline"></ion-icon>
                    </a>
                  </div>

                  <div
                    *ngIf="row.role === TENANT_USER_ROLES.STANDARD"
                    ngxTippy
                    data-tippy-content="Can access their own customers and conversations"
                    [tippyProps]="{
                      placement: 'bottom'
                    }"
                  >
                    Standard
                    <a (click)="changeRole(row.id)" *ngIf="authService.isTenantAdmin">
                      <ion-icon name="chevron-down-outline"></ion-icon>
                    </a>
                  </div>
                </ng-container>
              </ng-container>

              <ng-container *ngSwitchCase="'isAutoAssignable'">
                <ion-badge [color]="getIsAutoAssignableBadgeColor(row)">{{ getIsAutoAssignableLabel(row) }}</ion-badge>
                <a (click)="changeAutoAssignableSetting(row)">
                  <ion-icon name="chevron-down-outline"></ion-icon>
                </a>
              </ng-container>

              <ng-container *ngSwitchDefault>{{ value }}</ng-container>
            </ng-container>
          </div>
        </ng-template>
      </ngx-datatable-column>
    </ngx-datatable>
  </ion-card>
</ion-content>

<ion-modal [isOpen]="showTeamOptionsModal" (willDismiss)="showTeamOptionsModal = false" class="team-options-modal">
  <ng-template>
    <ion-header>
      <ion-toolbar>
        <ion-title>Team Options</ion-title>
        <ion-buttons slot="end">
          <ion-button (click)="showTeamOptionsModal = false">Close</ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
      <ion-card>
        <ion-list>
          <ion-item text-wrap>
            <ion-label style="white-space: normal">
              <h3>Anyone can respond to conversations</h3>
              <p>
                By default, any team member can respond to a request and mark a conversation in progress. If disabled,
                only team members who have been manually approved will be able to affect response times.
              </p>
            </ion-label>
            <label class="switch" slot="end">
              <input type="checkbox" [(ngModel)]="isUserAutoAssignableDefault" />
              <span class="slider"></span>
            </label>
          </ion-item>
          <ion-item text-wrap *ngIf="!isUserAutoAssignableDefault">
            <ion-label style="white-space: normal" color="warning">
              <ion-icon name="information-circle-outline"></ion-icon>
              Be sure that you've enabled some members of your team to be eligible to respond to conversations.
            </ion-label>
          </ion-item>
        </ion-list>
      </ion-card>
    </ion-content>
    <ion-footer class="team-options-modal-footer">
      <div class="flex-space-between">
        <div></div>
        <ion-button (click)="saveTeamOptions()" [disabled]="isLoadingTeamOptions">
          <ion-spinner name="crescent" [hidden]="!isLoadingTeamOptions" style="margin-left: 10px"></ion-spinner>
          Save
        </ion-button>
      </div>
    </ion-footer>
  </ng-template>
</ion-modal>
